import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-800 py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <h4 className="text-sm font-bold text-gray-300 uppercase tracking-wider mb-4 border-b border-gray-600 pb-2">
              Programs
            </h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('programs')} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Initial Assessment
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('programs')} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Arm Care Program
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('programs')} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Velocity Development
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('programs')} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Pro Prep Program
                </button>
              </li>
              <li>
                <Link to="/speed-agility" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Speed & Agility
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-300 uppercase tracking-wider mb-4 border-b border-gray-600 pb-2">
              Technology
            </h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('technology')} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  ArmCare
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('technology')} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Rapsodo
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('technology')} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  UpLift AI
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('technology')} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Axio Performance
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('technology')} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Vald
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('technology')} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Smart Speed
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('technology')} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Dynomat
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-300 uppercase tracking-wider mb-4 border-b border-gray-600 pb-2">
              About
            </h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Our Philosophy
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Success Stories
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-300 uppercase tracking-wider mb-4 border-b border-gray-600 pb-2">
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="text-gray-400 text-sm">
                Corsicana, TX
              </li>
              <li className="text-gray-400 text-sm">
                50 minutes south of Dallas
              </li>
              <li>
                <a href="mailto:info@eliteperformancelab.com" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  info@eliteperformancelab.com
                </a>
              </li>
              <li>
                <a href="tel:+12544245723" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  (254) 424-5723
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-600 pt-8">
          <div className="flex flex-col items-center gap-4 text-center">
            <div>
              <div className="text-xl sm:text-2xl font-black text-white mb-1">ELITE PERFORMANCE LAB</div>
              <div className="h-px w-full bg-gray-600 mb-2"></div>
              <div className="text-xs text-gray-500">Est. 2003 | Full-time since November 2021</div>
            </div>

            <div className="flex flex-col items-center gap-3">
              <div className="text-xs text-gray-500">© 2024 Elite Performance Lab. All rights reserved.</div>
              <div className="flex items-center gap-4">
                <a href="https://www.instagram.com/elite_performance_lab" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-gray-700 rounded-full hover:bg-teal-500 hover:text-white text-gray-400 transition-all cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
                <a href="https://www.facebook.com/ElitePerformanceLab1" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-gray-700 rounded-full hover:bg-teal-500 hover:text-white text-gray-400 transition-all cursor-pointer">
                  <i className="ri-facebook-line text-lg"></i>
                </a>
                <a href="https://www.youtube.com/@eliteperformancelab" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-gray-700 rounded-full hover:bg-teal-500 hover:text-white text-gray-400 transition-all cursor-pointer">
                  <i className="ri-youtube-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}